module.exports = __webpack_public_path__ + "img/17D65B79-8995-4408-8C1F-08D7B2BF1D1B.0fb680e5.svg";